import * as angular from "angular";
import * as _ from "lodash";
import {BringozToastService} from "../../commons/services/bringoz-toast.service";

export class PoliciesAlertsService {

  /* @ngInject */
  constructor(private bringozToastService: BringozToastService) {
  }

  // ******************************
  //        Public methods
  // ******************************

  // ADD USER //
  addUserSuccess() {
    const message = {
      body: 'POLICY_ADD_USER_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  addUserError(error) {
    const message = {
      body: 'POLICY_ADD_USER_ERROR',
      message: undefined
    };
    if (error && error.data?.code === 400212) {
      message.message = 'PASSWORD_TOO_SHORT'
    }
    return this.bringozToastService.error(message, {minimum: _.get(error.data, 'more_info')});
  }

  // REMOVE USER //
  removeUserSuccess() {
    const message = {
      body: 'POLICY_REMOVE_USER_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }


  removeUserError() {
    const message = {
      body: 'POLICY_REMOVE_USER_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // UPDATE IMAGE//
  updateImageSuccess() {
    const message = {
      body: 'POLICY_UPDATE_IMAGE_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  updateImageError() {
    const message = {
      body: 'POLICY_UPDATE_IMAGE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // UPDATE PASSWORD//
  updatePasswordSuccess() {
    const message = {
      body: 'POLICY_UPDATE_PASSWORD_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  updatePasswordError() {
    const message = {
      body: 'POLICY_UPDATE_PASSWORD_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // UPDATE INFO//
  updateInfoSuccess() {
    const message = {
      body: 'POLICY_UPDATE_INFO_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  updateInfoError() {
    const message = {
      body: 'POLICY_UPDATE_INFO_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // UPDATE ROLES//
  updateRolesSuccess() {
    const message = {
      body: 'POLICY_UPDATE_ROLES_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  updateRolesError() {
    const message = {
      body: 'POLICY_UPDATE_ROLES_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // UPDATE PASSWORD_POLICY//
  updatePasswordPolicySuccess() {
    const message = {
      body: 'POLICY_UPDATE_PASSWORD_POLICY_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  updatePasswordPolicyError() {
    const message = {
      body: 'POLICY_UPDATE_PASSWORD_POLICY_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // UPDATE BRANCHES//
  updateBranchesSuccess() {
    const message = {
      body: 'POLICY_UPDATE_BRANCHES_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  updateBranchesError() {
    const message = {
      body: 'POLICY_UPDATE_BRANCHES_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // ADD API KEY //
  addAPIKeySuccess() {
    const message = {
      body: 'POLICY_ADD_API_KEY_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  addAPIKeyError() {
    const message = {
      body: 'POLICY_ADD_API_KEY_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // REMOVE API KEY //
  removeAPIKeySuccess() {
    const message = {
      body: 'POLICY_REMOVE_API_KEY_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  removeAPIKeyError() {
    const message = {
      body: 'POLICY_REMOVE_API_KEY_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // INVALID ROLE SELECTION //
  invalidRoleSelectionInfo() {
    const message = {
      body: 'POLICY_INVALID_ROLE_SELECTION_INFO'
    };
    return this.bringozToastService.info(message)
  }

  getAllRolesGroups(){
    const message = {
      body: 'GET_ALL_ROLES_GROUPS_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  createRolesGroupError(){
    const message = {
      body: 'CREATE_ROLES_GROUPS_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  createRolesGroupSuccess(){
    const message = {
      body: 'CREATE_ROLES_GROUPS_SUCCESS',
    };
    return this.bringozToastService.success(message)
  }

  deleteRolesGroupError(){
    const message = {
      body: 'DELETE_ROLES_GROUPS_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  deleteRolesGroupSuccess(){
    const message = {
      body: 'DELETE_ROLES_GROUPS_SUCCESS',
    };
    return this.bringozToastService.success(message)
  }

  editRolesGroupError(){
    const message = {
      body: 'EDIT_ROLES_GROUPS_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  editRolesGroupSuccess(){
    const message = {
      body: 'EDIT_ROLES_GROUPS_SUCCESS',
    };
    return this.bringozToastService.success(message)
  }

  addMembersToGroupSuccess(){
    const message = {
      body: 'POLICY_ADD_MEMBERS_TO_GROUP_SUCCESS',
    };
    return this.bringozToastService.success(message)
  }

  addMembersToGroupError(){
    const message = {
      body: 'POLICY_ADD_MEMBERS_TO_GROUP_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  removeMembersFromGroupSuccess(){
    const message = {
      body: 'POLICY_REMOVE_MEMBERS_FROM_GROUP_SUCCESS',
    };
    return this.bringozToastService.success(message)
  }

  removeMembersFromGroupError(){
    const message = {
      body: 'POLICY_REMOVE_MEMBERS_FROM_GROUP_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  deleteGroupWithUsersInfo() {
    const message = {
      body: 'POLICY_DELETE_GROUP_WITH_USERS_INFO'
    };
    return this.bringozToastService.info(message)
  }

  editUserReportsSuccess(){
    const message = {
      body: 'EDIT_USER_REPORTS_SUCCESS',
    };
    return this.bringozToastService.success(message)
  }

  editUserReportsError(){
    const message = {
      body: 'EDIT_USER_REPORTS_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // IMPORT USERS //
  importAdminUsersSuccess() {
    const message = {
      body: 'IMPORT_ENTITIES_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  importAdminUsersError(error?) {
    const message = {
      body: 'IMPORT_ENTITIES_ERROR',
      details: 'SOMETHING_WENT_WRONG',
      message: _.get(error, 'more_info')
    };
    return this.bringozToastService.error(message)
  }

}

angular
  .module('bringoz.admin.policies')
  .service('policiesAlertsService', PoliciesAlertsService);


